import { Field } from "typegraph";

export default class Playlist {
	@Field()
	public bookmarked: boolean;
}



// WEBPACK FOOTER //
// ./src/panels/articleDetails/entities/Playlist.ts